import { Outlet } from "react-router-dom";
import UserHeader from "./UserHeader";
import UserSidebar from "./UserSidebar";

const UserLayout = () => {
    return (
        <>        
            <UserHeader /> 
            <div className="bg-[#F9FAFC] flex h-screen overflow-hidden  py-20">
                <div className="container m-auto">
                    <div className="flex flex-col md:flex-row">
                        <div className="basis-full md:basis-3/12  py-2 md:py-10 xl:py-12 "><UserSidebar /></div>
                        <div className="basis-full md:basis-9/12 py-6 md:py-10 xl:py-12 pl-2 md:pl-6 xl:pl-8 "><Outlet /></div>
                    </div>
                </div>                
            </div>          
        </>
    );
}
export default UserLayout;